var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOfflineMarketing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 0h40v40H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-1 -2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#80959D",
    strokeWidth: 0.8,
    d: "M2.327 25.365l.848-.53 4.043 6.47-.848.53z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#80959D",
    d: "M10.66 19.178l4.79 7.665 15.252-2.215-11.18-18.293zM8.556 31.555l7.062 6 4.962-3.1-7.068-5.997"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "rgba(21, 87, 191, 0.7)",
    strokeWidth: 1.6,
    d: "M23.86 7.73l3.838-4.466M31.074 19.275l5.967-1.874"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgba(21, 87, 191, 0.7)",
    d: "M1.922 24.153l8.34-5.212 5.212 8.34-8.34 5.212z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "rgba(21, 87, 191, 0.7)",
    strokeWidth: 1.6,
    d: "M27.5 13.556l7.876-5.132"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#80959D",
    d: "M17.851 8.858l9.919 15.939"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfflineMarketing);
export default __webpack_public_path__ + "static/media/offline-marketing.654e3ea8b99bc955ebbff6014a4b9ae4.svg";
export { ForwardRef as ReactComponent };